module.exports = __webpack_public_path__ + "img/down-arrow-small.546c00dc.svg";